import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

export const ICON_XY = 13;
const ICON_MARGIN_Y = 4;

export const StyledIcon = styled(SWReactIcons)`
    margin-right: ${ICON_MARGIN_Y}px;
`;
